<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="mb-5 background_color">
  <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" to="/issuetracking/index">{{language[1]['Home']}}  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/category/index"> {{language[106]['Manage Category']}}  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> {{main.main_cat_name}} </h6>


 


  <div class="container-fluid">


    <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>
    <template  #modal-title>
     
      <h5 >User Group</h5>


    </template>
    
   <div>
 
   
    <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
        <thead class="background_color2" >
         <tr class="custom-label2">
        <th>#</th>
        <th>Name</th>
        <th>User Type</th>
        <th>Status</th>
        <th>Action</th>

        </tr>
      </thead>
      <tbody>
        <tr v-for="(det, index) in dets" :key="det.group_id">
        <td>{{ index+1 }}</td>
        <td style="width: 30%;" >{{ det.user_name }}</td>
        <td style="width: 30%;">{{ det.usertype }}</td>
        <td >
          <div style="background-color: green;text-align: center;border-radius: 12px;padding: 2px;" v-show="det.statusvalue==1" >{{ det.status }} </div>
          <div style="background-color: red;text-align: center;border-radius: 12px;padding: 2px;" v-show="det.statusvalue==2" >{{ det.status }} </div>
        </td>
        <td> <button type="button" @click="dataDeletet(det.group_id,infoModal1.content)" class="btn btn-sm btn-outline-primary bdr-rad me-1 mb-1">Delete</button>
          <button type="button" v-show="det.statusvalue==2"  @click="activeGroup(det.group_id,det.statusvalue,infoModal1.content)" class="btn btn-sm btn-outline-primary bdr-rad">Active</button>
          <button type="button" v-show="det.statusvalue==1"  @click="activeGroup(det.group_id,det.statusvalue,infoModal1.content,)" class="btn btn-sm btn-outline-primary bdr-rad">Inactive</button>
        </td>
      </tr>
<tr>
      <td><b-icon @click="remove1" v-show="this.count1>0" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
      <td> <v-select class="font-size_def" v-model="groups[0].user_name" :options="usernames" label="username" @input="loadUsertype(0)" ></v-select>
       </td>
       <td> <input v-model="groups[0].usertype"  style="font-size: small;" class="form-control  bdr-rad" disabled>
        <input type="hidden" v-model="groups[0].userid"  style="font-size: small;" class="form-control  bdr-rad" disabled>
       </td>
       <td>
        <b-icon @click="add1" class=" mt-2 ms-4"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
       </td>
       <td></td>
      </tr>

      <tr v-for="key in count1" :key="key">
      <td><b-icon @click="remove1" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
      <td> <v-select class="font-size_def" v-model="groups[key].user_name"  :options="usernames" label="username" @input="loadUsertype(key)"></v-select>
       </td>
       <td> <input v-model="groups[key].usertype"  style="font-size: small;" class="form-control  bdr-rad" disabled >
        <input type="hidden" v-model="groups[key].userid"  style="font-size: small;" class="form-control  bdr-rad" disabled >
       </td>
       <td>
        <b-icon @click="add1" class=" mt-2 ms-4"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
       </td>
       <td></td>
      </tr>



      </tbody>
      
    </table>


   </div>
   <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="button"  @click="updateGroup(infoModal1.content)"  class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[78]['Update']}}</button>
    </div>
    </div>
  

  
  </b-modal>




 
    <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >
  

           
 

  
  

 



         

        <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>{{language[16]['Main Category']}} </b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>{{language[16]['Main Category']}} </th>
                              <th>{{language[108]['Code']}} </th>
                              <th>{{language[109]['From Date']}} </th>
                              <th>{{language[110]['To Date']}} </th>
                              <th >{{language[112]['Set Time']}}</th>
                              <th >{{language[113]['Message']}}</th>
                              <th >{{language[114]['Set Message']}}</th>
                              <th style="text-align: center;">{{language[22]['Status']}} </th>
                              <th style="text-align: center;">{{language[77]['Action']}} </th>
                            
                              </tr>
                            </thead>
                            <tbody>
                              <tr  >
                              <td>1</td>
                              <td>  <input  v-model="main.main_cat_name"  style="font-size: small;" class="form-control bdr-rad" ></td>
                              <td><input  v-model="main.code"  style="font-size: small;" class="form-control bdr-rad" ></td>
                              <td>
                                <!-- <input  v-model="main.from_date"  style="font-size: small;" class="form-control bdr-rad" type="date" > -->
                             
                                <DatePicker 
                              v-model="main.from_date"
                               :format="'MM/DD/YYYY'"
                              :placeholder="main.from_date"
                             
                              style="margin-top: 2px;"
                            
                            />
                         
                          
            
              
              
         
                              </td>
                              <td>
                              
                                <DatePicker 
                              v-model="main.to_date"
                               :format="'MM/DD/YYYY'"
                              :placeholder="main.to_date"
                             
                              style="margin-top: 2px;"
                            
                            />
                              </td> 

                              <td >     <div class="form-check form-switch ms-3">
                      <input v-model="main.per2" class="form-check-input" type="checkbox" @change="maintimeStatus(main.timestatus)">
                    
                    </div></td>

                    <td><input  v-model="main.message"  style="font-size: small;" class="form-control bdr-rad" ></td>
                    <td >     <div class="form-check form-switch ms-3">
                      <input v-model="main.per3" class="form-check-input" type="checkbox" @change="mainmessgeStatus(main.message_status)">
                    
                    </div></td>
                            
                              <td>
                                <div style="background-color: green;text-align: center;border-radius: 12px;padding: 4px;" v-show="main.statusvalue==1" >{{ main.status }} </div>
                              <div style="background-color: red;text-align: center;border-radius: 12px;padding: 4px;" v-show="main.statusvalue==2" >{{ main.status }} </div>
                             
                              </td>
                             
                              <td style="text-align: center;">     <div class="form-check form-switch">
                      <input v-model="main.per" class="form-check-input" type="checkbox" @input="mainStatus(main.statusvalue)">
                    
                    </div></td>
                            
                              </tr>
                            </tbody>

                          </table>
    
                        </div>

                        </div>
                    </div>



                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>{{language[17]['Sub Category']}} </b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                                <th>#</th>
                              <th>{{language[17]['Sub Category']}} </th>
                              <th>{{language[108]['Code']}} </th>
                              <th>{{language[109]['From Date']}} </th>
                              <th>{{language[110]['To Date']}} </th>
                              <th >{{language[112]['Set Time']}}</th>
                              <th >{{language[113]['Message']}}</th>
                              <th >{{language[114]['Set Message']}}</th>
                              <th >User Group</th>
                              <th style="text-align: center;">{{language[22]['Status']}} </th>
                              <th style="text-align: center;">{{language[77]['Action']}} </th>
                           
                            
                              </tr>
                            </thead>
                            <tbody> 
                            
                              <tr  v-for="(sub, index) in subs" :key="sub.id">
                             
                              <td  >{{index+1}}</td>
                              
                              <td>  <input  v-model="sub.sub_cat_name"  style="font-size: small;" class="form-control bdr-rad" ></td>
                              <td><input  v-model="sub.code"  style="font-size: small;" class="form-control bdr-rad" ></td>
                              <td>
                               
                                <DatePicker 
                              v-model="sub.from_date"
                               :format="'MM/DD/YYYY'"
                              :placeholder="sub.from_date"
                             
                              style="margin-top: 2px;"
                            
                            />
                              </td>
                              <td>
                             
                                <DatePicker 
                              v-model="sub.to_date"
                               :format="'MM/DD/YYYY'"
                              :placeholder="sub.to_date"
                             
                              style="margin-top: 2px;"
                            
                            />
                              </td> 
                              <td >     <div class="form-check form-switch ms-3">
                              <input v-model="sub.per2" class="form-check-input" type="checkbox" @change="subtimeStatus(sub.id,sub.per2,sub.from_date,sub.to_date,)">
                            
                            </div></td> 


                            <td><input  v-model="sub.message"  style="font-size: small;" class="form-control bdr-rad" ></td>
                    <td >     <div class="form-check form-switch ms-3">
                      <input v-model="sub.per3" class="form-check-input" type="checkbox" @change="submessgeStatus(sub.id,sub.per3)">
                    
                    </div></td>
                    <td> <button  @click="viewGroup(sub.id)"   class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad font-size_def">  View</button> </td>
                            
                              <td>
                                <div style="background-color: green;text-align: center;border-radius: 12px;padding: 4px;" v-show="sub.statusvalue==1" >{{ sub.status }} </div>
                              <div style="background-color: red;text-align: center;border-radius: 12px;padding: 4px;" v-show="sub.statusvalue==2" >{{ sub.status }} </div>
                             
                              </td>
                             
                              <td style="text-align: center;">     <div class="form-check form-switch">
                      <input v-model="sub.per" class="form-check-input" type="checkbox" @input="subStatus(sub.id,sub.statusvalue)">
                    
                    </div></td>
                            
                              </tr>
                              <tr>
                                <td><b-icon @click="remove" v-show="this.count>0" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
                                <td><input v-model="detail[0].category_name"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td><input v-model="detail[0].code"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td> 
                                  <DatePicker 
                              v-model="detail[0].from_date"
                               :format="'MM/DD/YYYY'"
                              placeholder="MM/DD/YYYY"
                             
                              style="margin-top: 2px;"
                            
                            />
                                
                                </td>
                                <td>  
                                  <DatePicker 
                              v-model="detail[0].to_date"
                               :format="'MM/DD/YYYY'"
                              placeholder="MM/DD/YYYY"
                             
                              style="margin-top: 2px;"
                            
                            />
                                </td>
                                <td></td>
                                <td><input  v-model="detail[0].message"  style="font-size: small;" class="form-control bdr-rad" ></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td> <b-icon @click="add" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
                            
                            </tr>
                            <tr v-for="key in count" :key="key">
                                <td><b-icon @click="remove" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
                                <td><input v-model="detail[key].category_name"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td><input v-model="detail[key].code"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td>  
                                  <DatePicker 
                              v-model="detail[key].from_date"
                               :format="'MM/DD/YYYY'"
                              placeholder="MM/DD/YYYY"
                             
                              style="margin-top: 2px;"
                            
                            />
                                </td>
                                <td> 
                                  <DatePicker 
                              v-model="detail[key].to_date"
                               :format="'MM/DD/YYYY'"
                              placeholder="MM/DD/YYYY"
                             
                              style="margin-top: 2px;"
                            
                            />
                                </td>
                                <td></td>
                                <td><input  v-model="detail[key].message"  style="font-size: small;" class="form-control bdr-rad" ></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td> <b-icon @click="add" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
                            
                            </tr>


                            </tbody>

                          </table>
    
                        </div>


  <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  @click="updatePage()" class="mr-1 btn btn-sm btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[78]['Update']}}</button>
    </div>
    </div>

       
             

              
              





                        </div>
                    </div>


   
    

    




</div>
</div>
</div>
<br><br><br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import vSelect from 'vue-select';
 import authService from '@/auth.service';
 import httpClient from '@/axios';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'
  import DatePicker from 'vue2-datepicker';

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        username:authService.isUsername(),
        language:JSON.parse(authService.isLanguage()),
        'id':this.$route.query.id,
    
        issue:{},
        lan:{},
        main: {},
        subs:[],
        contractors:[],
        alo_contractors:[],
        dets:[],
        crm:{
           followup_date: '',
        },
        uploadedFile1: '',  
        uploadedFile2: '',  
        uploadedFile3: '',  
        isLoading:true,
        count: 0,
        count1: 0,
        map: null, // Controls the visibility of the modal
      latitude: null, // Store latitude
      longitude: null,
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
        infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },
        infoModal3: {
          id: 'info-modal3',
          title: '',
          content: [],
        },
        infoModal4: {
          id: 'info-modal4',
          title: '',
          content: [],
        },
        infoModal5: {
          id: 'info-modal5',
          title: '',
          content: [],
        },

        infoModal6: {
          id: 'info-modal6',
          title: '',
          content: [],
        },

       
        usernames:[],
        detail:[
      {},  
      ],
      groups:[
      {},  
      ],
        
      }

    },
    mounted(){
 
  this.loadCrm();
  const today = new Date().toISOString().split('T')[0];
  this.crm.followup_date = today;
    },

    computed: {
    roundToTwoDecimal() {
      return detail => parseFloat(detail).toFixed(2);
    }
  },
methods : {

  
  formatDate(dateString) {
    const date = new Date(dateString); // Create a new Date object from the string

    // Manually format the date as DD-MM-YYYY with dashes
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`; // Combine date as DD-MM-YYYY
    
    // Format the time as HH:MM in 24-hour format
    const formattedTime = date.toLocaleTimeString('en-GB', {  
      hour: '2-digit', minute: '2-digit'
    });

    return `${formattedDate} ${formattedTime}`;  // Combine date and time
  },


  async loadUsertype(id){

    // console.log(this.groups[id].user_name.usertype);

    this.groups[id].usertype = this.groups[id].user_name.usertype;
    this.groups[id].userid = this.groups[id].user_name.userid;


  },


  async activeGroup(groupid,status,subid){
 
  
   try {
    const { data } = await httpClient.get(`/web/api/issuetracking/statuschangegroup`, {
  params: {
    id: groupid,
    status: status,
  },
  headers: {
    Authorization: `Bearer ${this.access_token}`,
    'Content-Type': 'application/json',
  },
});
      console.log(data);
      if(data.status==200){
      this.viewGroup(subid);

      
       
      }
     
   } catch (error) {
     console.log(error.response);
   }
   
   
   
   },

  
  async dataDeletet(id,subid){
   
  
   try {
     const { data} = await  httpClient.get('/web/api/issuetracking/deletegroup?id='+id,{
       headers:{
         'Authorization':'Bearer '+this.access_token,
         'Content-type': 'application/json',
        
       }
      });
      console.log(data);
      if(data.status==200){
      this.viewGroup(subid);

      
       
      }
     
   } catch (error) {
     console.log(error.response);
   }
   
   
   
   },


  async updateGroup(id){
   
  
   try {
     const { data} = await  httpClient.post('/web/api/issuetracking/updategroup?id='+id,{groups:this.groups},{
       headers:{
         'Authorization':'Bearer '+this.access_token,
         'Content-type': 'application/json',
        
       }
      });
      console.log(data);
      if(data.status==200){
     
      this.viewGroup(id);

      
       
      }
     
   } catch (error) {
     console.log(error.response);
   }
   
   
   
   },


  async viewGroup(id){
   
   
try {
  const { data} = await  httpClient.get('/web/api/issuetracking/loadusergroup?id='+id,{
    headers:{
      'Authorization':'Bearer '+this.access_token,
      'Content-type': 'application/json',
     
    }
   });
   console.log(data);

   if(data.status==200){
    this.dets = data.dets;
    this.usernames = data.usernames;
    this.infoModal1.content = id;
    this.$root.$emit('bv::show::modal', this.infoModal1.id);
    this.count1 = ''; // Clear count1 (set to empty string or default value)
this.groups = [
  {
    userid: '',
    usertype: '',
    user_name: '',
  },
];

   }
  
} catch (error) {
  console.log(error.response);
}



},


  async updatePage() {
   
   try {
     const { data} = await  httpClient.post('/web/api/issuetracking/catecoryupdate',{main:this.main,subs:this.subs,detail:this.detail},{
       headers:{
         'Authorization':'Bearer '+this.access_token,
         'Content-type': 'application/json',
        
       }
      });
      console.log(data);
      if(data.status==200){
        window.location.reload();
      }
     
     
     
      
     
   } catch (error) {
     console.log(error.response);
   }
 },



  

 
    


   
  


 





  
  async loadCrm() {
   
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/catecoryview?id='+this.id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      
       this.main = data.main;
       this.subs = data.sub;
      
       console.log(this.uploadedFiles);
       this.isLoading= false;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  async maintimeStatus(id) {
 
 try {
   const { data} = await  httpClient.post('/web/api/issuetracking/maintimestatus?id='+id,{main:this.main},{
     headers:{
       'Authorization':'Bearer '+this.access_token,
       'Content-type': 'application/json',
      
     }
    });
    console.log(data);
   if(data.status==200){
     this.loadCrm();
   }
   
   
 } catch (error) {
   console.log(error.response);
 }
},
  async mainmessgeStatus(id) {
 
 try {
   const { data} = await  httpClient.post('/web/api/issuetracking/mainmessgestatus?id='+id,{main:this.main},{
     headers:{
       'Authorization':'Bearer '+this.access_token,
       'Content-type': 'application/json',
      
     }
    });
    console.log(data);
  //  if(data.status==200){
  //    this.loadCrm();
  //  }
   
   
 } catch (error) {
   console.log(error.response);
 }
},

async subtimeStatus(id,per,from_date,to_date) {
 
 try {
   const { data} = await  httpClient.post('/web/api/issuetracking/subtimestatus',{id:id,per:per,from_date:from_date,to_date:to_date},{
     headers:{
       'Authorization':'Bearer '+this.access_token,
       'Content-type': 'application/json',
      
     }
    });
    console.log(data);
   if(data.status==200){
     this.loadCrm();
   }
   
   
 } catch (error) {
   console.log(error.response);
 }
},
async submessgeStatus(id,per) {

  console.log(per);
 
 try {
   const { data} = await  httpClient.post('/web/api/issuetracking/submessagestatus',{id:id,per:per},{
     headers:{
       'Authorization':'Bearer '+this.access_token,
       'Content-type': 'application/json',
      
     }
    });
    console.log(data);
  //  if(data.status==200){
  //    this.loadCrm();
  //  }
   
   
 } catch (error) {
   console.log(error.response);
 }
},



  async mainStatus(id) {
 
    try {
      const { data} = await  httpClient.post('/web/api/issuetracking/mainstatus?id='+id,{catogeryid:this.id},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      if(data.status==200){
        this.loadCrm();
      }
      
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async subStatus(subid, statusvalue) {

  
 
 try {
   const { data} = await  httpClient.post('/web/api/issuetracking/substatus?subid='+subid,{statusvalue:statusvalue},{
     headers:{
       'Authorization':'Bearer '+this.access_token,
       'Content-type': 'application/json',
      
     }
    });
    console.log(data);
   if(data.status==200){
     this.loadCrm();
   }
   
   
 } catch (error) {
   console.log(error.response);
 }
},


  jobView(id){
    this.$router.push('/issuetracking/jobview?id='+id);
  },


  add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },
  add1: function(){

   
            this.count1++;
            this.groups.push({
             
            },)
           
        },

  remove1: function () {
            this.count1--;
            this.groups.splice({
              
            },1)
            
        },




},

    components :{
        ContentFooter,
        DatePicker,
        TopNavbar,
         'v-select': vSelect,
    },
  }

</script>
<style >

</style>